export const EMAIL_ADDRESS = 'info@scriptedbykat.com';

export const WHATSAPP_DEFAULT_MESSAGE =
  'Hi, I would like to know more about your restaurant website services.';

export const createWhatsAppUrl = (message: string = WHATSAPP_DEFAULT_MESSAGE) => {
  const part1 = 'KzQ0';
  const part2 = 'Nzg5';
  const part3 = 'MTgxO';
  const part4 = 'TIzOQ==';
  const encodedNumber = part1 + part2 + part3 + part4;
  const number = atob(encodedNumber);
  const encodedMessage = encodeURIComponent(message);
  return `https://wa.me/${number}${message ? `?text=${encodedMessage}` : ''}`;
};

export const CONTACT_URL = {
  email: `mailto:${EMAIL_ADDRESS}`,
  whatsapp: createWhatsAppUrl(),
};

export interface ContactDataType {
  id: string;
  title: string;
  description: string;
  iconName: string;
  href: string;
}

export const CONTACT_DATA: ContactDataType[] = [
  {
    id: 'email',
    title: 'Email',
    description: "I'd love to hear from you!",
    iconName: 'HiOutlineEnvelope',
    href: `mailto:${EMAIL_ADDRESS}`,
  },
  {
    id: 'whatsapp',
    title: 'WhatsApp',
    description: 'Quick and easy messaging for instant support.',
    iconName: 'FaWhatsapp',
    href: CONTACT_URL.whatsapp,
  },
  {
    id: 'location',
    title: 'Location',
    description: 'Serving clients remotely, based in South London.',
    iconName: 'HiOutlineMapPin',
    href: 'https://www.google.com/maps/place/South+London',
  },
];
